// Mapeamentos de valores para labels user-friendly
// Baseado nos valores do MockValues e useHome

export const classificacaoTrocaMap = {
  "pedido_classificacao_da_troca_acordo_judicial_/_procon": "Acordo Judicial / Procon",
  "pedido_classificacao_da_troca_aguardando_retirada": "Aguardando retirada", 
  "pedido_classificacao_da_troca_alçada_reclame_aqui": "Alçada Reclame Aqui",
  "pedido_classificacao_da_troca_análise_engenharia__sinistro/produto_para_análise_": "Análise engenharia (sinistro/produto para análise)",
  "pedido_classificacao_da_troca_atraso_de_entrega": "Atraso de entrega",
  "pedido_classificacao_da_troca_cliente_ausente": "Cliente ausente",
  "pedido_classificacao_da_troca_defeito_estético": "Defeito estético",
  "pedido_classificacao_da_troca_defeito_funcional": "Defeito funcional",
  "pedido_classificacao_da_troca_endereço_não_localizado": "Endereço não localizado",
  "pedido_classificacao_da_troca_entrega_divergente": "Entrega divergente",
  "pedido_classificacao_da_troca_envio_brinde": "Envio Brinde",
  "pedido_classificacao_da_troca_erro_de_anúncio": "Erro de anúncio",
  "pedido_classificacao_da_troca_extravio_/_sinistro": "Extravio / Sinistro",
  "pedido_classificacao_da_troca_falha_da_logistica": "Falha da logistica",
  "pedido_classificacao_da_troca_falha_do_posto_autorizado": "Falha do posto autorizado",
  "pedido_classificacao_da_troca_faltando_acessórios/_danificado": "Faltando acessórios/ danificado",
  "pedido_classificacao_da_troca_não_integrado": "Não integrado",
  "pedido_classificacao_da_troca_pedido_entregue_parcial": "Pedido entregue parcial",
  "pedido_classificacao_da_troca_produto_de_troca_apresentou_defeito": "Produto de Troca Apresentou Defeito",
  "pedido_classificacao_da_troca_produto_enviado_em_cortesia": "Produto enviado em cortesia",
  "pedido_classificacao_da_troca_reincidência": "Reincidência",
  "pedido_classificacao_da_troca_sem_motivo_técnico_/_reclamação": "Sem motivo técnico / Reclamação",
  "pedido_classificacao_da_troca_tutela": "Tutela",
  "pedido_classificacao_da_troca_voltagem_errada": "Voltagem errada"
} as const;

export const plataformasMap = {
  "pedido_plataforma_aj_place": "AJ Place",
  "pedido_plataforma_amazon": "Amazon",
  "pedido_plataforma_angeloni": "Angeloni",
  "pedido_plataforma_b2w": "B2W",
  "pedido_plataforma_balaroti": "Balaroti",
  "pedido_plataforma_banco_inter": "Banco Inter",
  "pedido_plataforma_best_off": "Best Off",
  "pedido_plataforma_bradesco": "Bradesco",
  "pedido_plataforma_britânia": "Britânia",
  "pedido_plataforma_britânia_em_casa": "Britânia em Casa",
  "pedido_plataforma_c_a": "C&A",
  "pedido_plataforma_camicado": "Camicado",
  "pedido_plataforma_canal_rural": "Canal Rural",
  "pedido_plataforma_carrefour": "Carrefour",
  "pedido_plataforma_casa_e_vídeo": "Casa e Vídeo",
  "pedido_plataforma_cassol": "Cassol",
  "pedido_plataforma_clube_de_compras": "Clube de compras",
  "pedido_plataforma_cnova": "Cnova",
  "pedido_plataforma_colombo": "Colombo",
  "pedido_plataforma_compra_certa": "Compra Certa",
  "pedido_plataforma_coopera": "Coopera",
  "pedido_plataforma_droga_raia": "Droga Raia"
} as const;

export const retiraMap = {
  "ag_joinville": "AG - Joinville",
  "cd_joinville": "CD - Joinville", 
  "prime_joinville": "Prime - Joinville",
  "matriz_curitiba": "Matriz - Curitiba",
  "marechal_curitiba": "Marechal - Curitiba"
} as const;

export const statusIntegracaoMap = {
  "pedido_status_da_integracao_aguardando": "Aguardando",
  "pedido_status_da_integracao_em_andamen": "Em andamento",
  "pedido_status_da_integracao_erro": "Erro",
  "pedido_status_da_integracao_integrado": "Integrado",
  "pedido_status_da_integracao_não_integ": "Não integrado",
  "pedido_status_da_integracao_pendente": "Pendente"
} as const;

export const avaliacaoCreditoMap = {
  "pedido_avaliacao_de_credito_aprovado": "Aprovado",
  "pedido_avaliacao_de_credito_negado": "Negado", 
  "pedido_avaliacao_de_credito_pendente": "Pendente",
  "pedido_avaliacao_de_credito_em_analise": "Em análise",
  "pedido_avaliacao_de_credito_sim": "Sim",
  "pedido_avaliacao_de_credito_nao": "Não"
} as const;

export const tipoRegistroMap = {
  "pedido_tipo_do_registro_produto": "Produto",
  "pedido_tipo_do_registro_servico": "Serviço",
  "pedido_tipo_do_registro_combo": "Combo",
  "pedido_tipo_do_registro_kit": "Kit"
} as const;

export const tipoEnvioMap = {
  "pedido_tipo_de_envio_do_pedido_cortesia": "Cortesia",
  "pedido_tipo_de_envio_do_pedido_garantia": "Garantia", 
  "pedido_tipo_de_envio_do_pedido_venda": "Venda"
} as const;

// Funções helper para mapear valores
export const mapClassificacaoTroca = (value: string): string => {
  return classificacaoTrocaMap[value as keyof typeof classificacaoTrocaMap] || value;
};

export const mapPlataforma = (value: string): string => {
  return plataformasMap[value as keyof typeof plataformasMap] || value;
};

export const mapRetira = (value: string): string => {
  return retiraMap[value as keyof typeof retiraMap] || value;
};

export const mapStatusIntegracao = (value: string): string => {
  return statusIntegracaoMap[value as keyof typeof statusIntegracaoMap] || value;
};

export const mapAvaliacaoCredito = (value: string): string => {
  return avaliacaoCreditoMap[value as keyof typeof avaliacaoCreditoMap] || value;
};

export const mapTipoRegistro = (value: string): string => {
  return tipoRegistroMap[value as keyof typeof tipoRegistroMap] || value;
};

export const mapTipoEnvio = (value: string): string => {
  return tipoEnvioMap[value as keyof typeof tipoEnvioMap] || value;
};
